import i18n from '../i18n'; 

export function filterLanguage(arr){
    return arr.locales.filter((l)=>(l.locale === i18n.language))
} 
export function filterHeaders(arr){
    return arr.filter((l)=>(l.locale === i18n.language))
} 